import { Component, OnInit, Input, ViewChild, Renderer2, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'app-map-park',
  templateUrl: './map-park.component.html',
  styleUrls: ['./map-park.component.scss']
})
export class MapParkComponent implements OnInit {

  @Input() data: any;
  @ViewChild('parkMap', {static: true}) protected mapDivRef: ElementRef;

  map: any;
  layerGroup: any;
  layerGroupShapes: any;
  filteredSedes: any = [];

  protected mapDiv: HTMLDivElement;

  constructor() { }

  ngOnInit(): void {
    this.mapDiv = this.mapDivRef.nativeElement;

    // console.log("init map park ", this.data);

    const myAPIKey = "0162482e691040afa6ac3cbfc6dbc92d";
    const mapStyle = "https://maps.geoapify.com/v1/styles/osm-carto/style.json";

    this.map = L.map('parkMap', { scrollWheelZoom: false }).setView([19.400119, -99.194519], 12);

    // 19.369903, -99.148074
    // L.ZoomControl({ postion: 'bottomright' }).addTo(this.map);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
 			maxZoom: 16,
 			minZoom: 10,
 		}).addTo(this.map);

    // INIT layerGroups
    this.layerGroup = L.layerGroup().addTo(this.map);
    this.layerGroupShapes = L.layerGroup().addTo(this.map);

    let anio = this.data.filters.filter(el => el.ano == 2019);
    // console.log("anio ==> ", anio);
    let mes = anio.filter(el => el.mes == "Enero");
    // console.log("mes ==> ", mes);

    this.buildMap(mes);
  }

  private async buildMap (data) {
    data.map(async (arr) => {
      // console.log("MAP arr => ", arr);
      if (arr.geo_shape != "" || arr.geo_shape == undefined) {
        L.geoJSON(JSON.parse(arr.geo_shape), {
          style: {
            "color": "#1D4439",
            "fillColor": "#8DB85D",
            "weight": 5,
            "fillOpacity": 0.54
          }
        }).on('mouseover', function (e) {
          e.layer.bindTooltip(`
            <div style="background: white; color: black; padding: 8px; border-radius: 8px; ">
              <h3>${arr.poligono}</h3>
              <p class="mb-0">Concesionaria: ${arr.concesionaria}</p>
              <p class="mb-0">Inmovilizaciones: ${arr.numero_de_inmovilizaciones}</p>
              <p class="mb-0">Total ingreso: $${arr.ingreso}</p>
              <p class="mb-0">Total inmovilizador: $${arr.total_inmovilizador}</p>
            </div>
          `, { closeButton: true });
        }).addTo(this.layerGroupShapes);
      }
    });
  }

  public async changeFilterYear(event: any) {}

  public async changeFilterMonth(event: any) {

    // console.log("EVENT > ", event.target.value)
    let anios = document.getElementById("anio");
    // console.log("anios ==> ", anios);

    this.layerGroupShapes.clearLayers();
    let anio = this.data.filters.filter(el => el.ano == 2019);
    // console.log("anio ==> ", anio);
    let mes = anio.filter(el => el.mes == event.target.value);
    // console.log("mes ==> ", mes);

    this.buildMap(mes);
  }
}
